import { configureStore } from '@reduxjs/toolkit';
import rootReducer from '../reducers';

export default function configureAppStore(preloadedState = {}) {
  const store = configureStore({
    reducer: rootReducer,
    preloadedState,
    devTools: process.env.NODE_ENV !== 'production',
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        thunk: {
          extraArgument: {}, // You can pass extra arguments to thunk middleware if needed
        },
        serializableCheck: false, // Disable serializable checks if needed
        immutableCheck: false, // Disable immutable checks if needed
      }),
  });

  return store;
}
